import {HttpPromiseState, watchHttpPromise} from '../../lib/helpers/promise/HttpPromiseState';
import {environment} from '../../lib/environment';
import {PagedListResponse, SuccessResponse} from '../index';
import {
  SetPasswordModel,
  SetTimeZoneRequest,
  StudentProfileUpdateModel,
  UpdateOwnPasswordModel,
  User,
  UserSearchModel,
  UserUpdateModel
} from '../models/user';
import {httpClient} from '../utils/httpClient';
import { AxiosResponse } from 'axios';

export class UserLoaderClass {
  search(request: UserSearchModel): HttpPromiseState<PagedListResponse<User>> {
    let url = `${environment.apiServer}/user/search`;
    return httpClient.state.post<PagedListResponse<User>>(url, request);
  }

  get(userId: number): HttpPromiseState<User> {
    let url = `${environment.apiServer}/user/${userId}`;
    return httpClient.state.get<User>(url);
  }

  create(request: UserUpdateModel): HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/user`;
    return httpClient.state.post<SuccessResponse>(url, request);
  }

  update(userId: number, request: UserUpdateModel): HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/user/${userId}`;
    return httpClient.state.put<SuccessResponse>(url, request);
  }

  delete(userId: number): HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/user/${userId}`;
    return httpClient.state.delete<SuccessResponse>(url);
  }

  setPassword(userId: number, password: string): HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/user/${userId}/set-password`;
    let model: SetPasswordModel = {NewPassword: password};
    return httpClient.state.put<SuccessResponse>(url, model);
  }

  setTimeZone(userId: number, timeZoneId: number): HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/user/${userId}/set-timezone`;
    let model: SetTimeZoneRequest = {TimeZoneId: timeZoneId};
    return httpClient.state.put<SuccessResponse>(url, model);
  }

  updateMyPassword(oldPassword: string,
                   newPassword: string): HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/user/update-my-password`;
    let model: UpdateOwnPasswordModel = {
      OldPassword: oldPassword,
      NewPassword: newPassword
    };
    return httpClient.state.put<SuccessResponse>(url, model);
  }

  updateMyTimezone(timeZoneId: number): HttpPromiseState<SuccessResponse> {
    let url = `${environment.apiServer}/user/update-my-timezone`;
    let model: SetTimeZoneRequest = {TimeZoneId: timeZoneId};
    return httpClient.state.put<SuccessResponse>(url, model);
  }

  updateStudentProfile(request: FormData): HttpPromiseState<SuccessResponse> {
    const url = `${environment.apiServer}/student/update-student-profile`;
    return httpClient.state.put<SuccessResponse>(url, request, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
    });
  }
}

export const userLoaders = new UserLoaderClass();
